import React, { useRef, useEffect } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";

const EducationBackground = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const inputRef = useRef();

	useEffect(() => { 
		inputRef.current.focus();
	},[])

	const { data, handleChange, regularData } = useRegistrationContext();

	const content = (
		<>
			<fieldset className="col-sm-8">
				<div className="form-group row">
					<label
						htmlFor="last_tertiary_institution"
						className="col-sm-4 label-text"
					>
						Last Tertiary Institution Attended<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<input
							ref={inputRef}
							type="text"
							id="last_tertiary_institution"
							autoComplete="off"
							style={{
								textTransform: "uppercase",
							}}
							onChange={handleChange}
							value={data.educationLastTertiaryInstitution}
							name="educationLastTertiaryInstitution"
							className="form-control"
						/>
					</div>
				</div>
				<div className="form-group row">
					<label className="col-sm-4 label-text">
						Qualification Type<span>&nbsp;&nbsp;*</span>
					</label>
					{regularData?.qualificationType.map((item, index) => (
						<div className="col-sm-2" key={index}>
							<label htmlFor={`qualification_type${item.id}`}>
								<input
									type="checkbox"
									id={`qualification_type${item.id}`}
									name="educationQualificationType"
									checked={
										data.educationQualificationType ===
										item.value
									}
									value={item.value}
									onChange={handleChange}
								/>
							</label>
							<span className="checkbox-label">{item.label}</span>
						</div>
					))}
				</div>
				<div className="form-group row">
					<label
						htmlFor="qualification"
						className="col-sm-4 label-text"
					>
						Qualification<span>&nbsp;&nbsp;</span>
					</label>
					<div className="col-sm-8">
						<input
							type="text"
							id="qualification"
							autoComplete="off"
							style={{
								textTransform: "uppercase",
							}}
							onChange={handleChange}
							value={data.educationQualification}
							name="educationQualification"
							className="form-control"
						/>
					</div>
				</div>
			</fieldset>
		</>
	);

	return content;
};
export default EducationBackground;
